import { extendObservable, action } from 'mobx';

// indexed by twilioNumber / twilioSid

export class Property {
  constructor(props = {}) {
    let {
      id, // twilioNumber or twilioSid?
      userId,
      name = "",
      address = "",
      twilioNumber = "",
      twilioSid,
      doorOpenNumber = "", // # to reply to open the door
      intial = false,
    } = props;

    extendObservable(this, {
      id: id,
      userId: userId,
      name: name,
      address: address,
      twilioNumber: twilioNumber,
      twilioSid: twilioSid,
      doorOpenNumber: doorOpenNumber,
      intial: intial,
    });
  }

  set = action((props = {}) => {
    for (let key in props) {
      this[key] = props[key];
    }
  });

  get = () => {
    return JSON.parse(JSON.stringify(this));
  }
}

export default Property;


// WEBPACK FOOTER //
// ./src/models/Property.js